import {
  Convocatoria,
  initialValuesConvocatoria,
} from "../ConvocatoriasModel/convocatoria.model";

export interface Jurado {
  id_jurado: number;
  tipo_identificacion: string;
  numero_documento: string;
  path_documento: string;
  path_foto: string;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  perfil: string;
  fecha_nacimiento: string;
  genero: string;
  pais_nacimiento: string;
  departamento_residencia: string;
  municipio_residencia: string;
  comuna_residencia: string;
  barrio: string;
  direccion: string;
  estrato: string;
  correo_electronico: string;
  telefono_fijo: string;
  telefono_celular: string;
  areas_conocimientos: any;
  reconocimientos: any;
  publicaciones: any;
  experiencias: any;
  educacion_formal: any;
  educacion_no_formal: any;
  experiencias_profesionales: any;
  fecha_creacion: any;
  fecha_modificacion: any;
  identidad_genero: string;
  orientacion_sexual: string;
  etnia: string;
  asignado: any;
  criterio: boolean;
  firma: string;
}

export const initialValuesModelJurado = {
  id_jurado: 1,
  tipo_identificacion: "",
  numero_documento: "",
  path_documento: "",
  path_foto: "",
  primer_nombre: "",
  segundo_nombre: "",
  primer_apellido: "",
  segundo_apellido: "",
  perfil: "",
  fecha_nacimiento: "",
  genero: "",
  pais_nacimiento: "",
  departamento_residencia: "",
  municipio_residencia: "",
  comuna_residencia: "",
  barrio: "",
  direccion: "",
  estrato: "",
  correo_electronico: "",
  telefono_fijo: "",
  telefono_celular: "",
  areas_conocimientos: [],
  reconocimientos: [],
  publicaciones: [],
  experiencias: [],
  educacion_formal: [],
  educacion_no_formal: [],
  experiencias_profesionales: [],
  fecha_creacion: [],
  fecha_modificacion: [],
  identidad_genero: "",
  orientacion_sexual: "",
  etnia: "",
  asignado: [],
  criterio: false,
  firma: "",
};
export interface Jurados {
  convocatoria: Convocatoria;
  activeTab: string;
}

export const initialValuesinfoJurados: Jurados = {
  convocatoria: initialValuesConvocatoria,
  activeTab: "1",
};

export interface Area {
  id_area: number;
  nombre_area: string;
  categorias_areas: Categoria[];
}

export interface Categoria {
  area_id: number;
  id_categoria: number;
  nombre: string;
  checked: boolean;
}

export interface EducacionNoFormal {
  nombre_educacion: string;
  nombre_proceso: string;
  duracion: string;
  institucion?: string;
  fecha_inicio: string;
  fecha_terminacion: string;
  numero_horas: string;
  ciudad: string;
  path_anexo: string;
}

export interface EducacionFormal {
  nivel_educacion: string;
  titulo: string;
  institucion_educativa: string;
  ciudad: string;
  graduado: boolean;
  fecha_graduacion: string;
  path_anexo: string;
}

export interface InvitacionJurado {
  invitacion_profesional: number;
  nombre_completo: string;
  correo: string;
}

export interface ProyectoJurado {
  id_postulacion: number;
  nombre_propuesta: string;
  codigo: string;
  linea: number;
  categoria: any;
}
